import { PhotoCapture } from '../enums';
export const PHOTO_CAPTURE_UPDATE_CONTEXT_DATA_REQUEST = `${PhotoCapture.PHOTO_CAPTURE}_UPDATE_CONTEXT_DATA_REQUEST`;
export const PHOTO_CAPTURE_UPDATE_CONTEXT_DATA_SUCCESS = `${PhotoCapture.PHOTO_CAPTURE}_UPDATE_CONTEXT_DATA_SUCCESS`;
export const PHOTO_CAPTURE_RESET_CONTEXT = `${PhotoCapture.PHOTO_CAPTURE}_RESET_CONTEXT`;
export const photoCaptureUpdateContextDataAction = (contextDataUpdateInput, contextId, coCode, selectedShopIdByUser, isShopUpdatedByUser) => ({
    type: PHOTO_CAPTURE_UPDATE_CONTEXT_DATA_REQUEST,
    payload: {
        contextId,
        coCode,
        contextDataUpdateInput,
        selectedShopIdByUser,
        isShopUpdatedByUser
    }
});
export const photoCaptureUpdateContextDataSuccessAction = (selectedShopIdByUser, isShopUpdatedByUser) => ({
    type: PHOTO_CAPTURE_UPDATE_CONTEXT_DATA_SUCCESS,
    payload: {
        selectedShopIdByUser,
        isShopUpdatedByUser
    }
});
export const photoCaptureResetContextAction = () => ({
    type: PHOTO_CAPTURE_RESET_CONTEXT
});
//# sourceMappingURL=photoCaptureUpdateContextAction.js.map